import { Link } from "react-router-dom";

export const NotFound = () => (
    <section className="section flex min-h-[70vh] items-center pt-40">
        <div className="shell text-center">
            <p className="label-tech">ERROR 404 — UNVERIFIED ROUTE</p>
            <h1 className="mt-6 font-display text-5xl font-bold uppercase tracking-tightest md:text-7xl">
                NOTHING <span className="text-[#1677FF]">PROVEN</span> HERE.
            </h1>
            <p className="mx-auto mt-5 max-w-md text-mute">
                This page does not exist in the protocol. Return to verified territory.
            </p>
            <Link
                to="/"
                data-testid="notfound-home-link"
                className="mt-10 inline-block bg-[#1677FF] px-8 py-4 font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-white transition-colors hover:bg-[#3D8BFF]"
            >
                BACK TO ACTRA
            </Link>
        </div>
    </section>
);

export default NotFound;
